/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './map.scss';

/* eslint-disable import/no-unresolved, import/default */
import mapTemplate from './map.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.map', [])
    .directive('tkMap', Map)
    .name;

function Map($compile, $mdConstant, $templateCache, NgMap) {

    return {
        restrict: "E",
        scope: {
            markers: '=',
        },
        link: linker
    };

    function linker(scope, element) {

        var template = $templateCache.get(mapTemplate);
        
        element.html(template);

        scope.getStringValue = val => val.toString();

        scope.defaultMapCenter = {
            lat: 0,
            lng: 0,
            zoom: 2
        };

        NgMap.getMap().then(function(map) {
            scope.map = map;

            NgMap.getGeoLocation('').then(function(location) {
                scope.defaultMapCenter = {
                    lat: location.lat(),
                    lng: location.lng(),
                    zoom: 12
                }

                scope.currentMapCenter = scope.defaultMapCenter;

                scope.map.showInfoWindow = scope.map.showInfoWindow ||
                function(mapEvent, p2, mapMarker) { //event, id, marker
                    const id = typeof mapEvent == 'string' ? mapEvent : p2;
                    let marker = typeof mapEvent == 'string' ? p2 : mapMarker;
                    if (typeof marker == 'string') {
                        marker = scope.map.markers[marker];
                    }

                    const infoWindow = scope.map.infoWindows[id];
                    const anchor = marker ? marker : (this.getPosition ? this : null);
                    infoWindow.__open(scope.map, scope, anchor);
                    if(scope.singleInfoWindow) {
                        if(scope.lastInfoWindow) {
                            scope.hideInfoWindow(scope.lastInfoWindow);
                        }
                        scope.lastInfoWindow = id;
                    }
                };

                scope.map.hideInfoWindow = scope.map.hideInfoWindow ||
                    function(p1, p2) {
                        const id = typeof p1 == 'string' ? p1 : p2;
                        const infoWindow = scope.map.infoWindows[id];
                        infoWindow.close();
                    };
            });
        });

        scope.showDetail = function (e, marker) {
            scope.marker = marker;
            scope.map.showInfoWindow('marker-info', marker.title);
        };

        scope.hideDetail = function() {
            scope.map.hideInfoWindow('marker-info');
        };

        scope.$watch('markers', function (newMarkers) {
            scope.updateMapCenter(newMarkers);
        });

        scope.updateMapCenter = function(markers) {
            if (markers && markers.length) {
                let latitudeSum = 0;
                let longitudeSum = 0;
                const markersLength = markers.length;

                for (let i = 0; i < markersLength; i++) {
                    const marker = markers[i];

                    if (marker && marker.lat && marker.lng) {
                        latitudeSum += marker.lat;
                        longitudeSum += marker.lng;
                    }
                }

                scope.currentMapCenter.lat = latitudeSum ? latitudeSum / markersLength : scope.defaultMapCenter.lat;
                scope.currentMapCenter.lng = longitudeSum ? longitudeSum / markersLength : scope.defaultMapCenter.lng;
                scope.currentMapCenter.zoom = scope.defaultMapCenter.zoom;
            } else {
                scope.currentMapCenter = scope.defaultMapCenter;
            }
        };

        $compile(element.contents())(scope);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/map.directive.js